import {
  GET_AUDIENCE_COUNT_START,
  GET_AUDIENCE_COUNT_SUCCESS,
  GET_AUDIENCE_COUNT_ERROR,
} from 'constants/action-types/organizations/audienceCount';
import apiAction from 'helpers/apiAction';

export default params => dispatch =>
  dispatch(
    apiAction({
      url: '/organizations/audience/count',
      queries: params,
      method: 'GET',
      API_REQUEST_START: GET_AUDIENCE_COUNT_START,
      API_REQUEST_FAILURE: GET_AUDIENCE_COUNT_ERROR,
      onSuccess: data => {
        return dispatch({
          type: GET_AUDIENCE_COUNT_SUCCESS,
          payload: data?.count ?? 0,
        });
      },
      onEnd: () => false,
    }),
  );
